var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarCalendarYellowReversed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Badge"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#BC955C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#855F2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M6 3L6.67354 5.07295H8.85317L7.08981 6.3541L7.76336 8.42705L6 7.1459L4.23664 8.42705L4.91019 6.3541L3.14683 5.07295H5.32646L6 3Z",
    fill: "#BC955C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCalendarYellowReversed);
export default __webpack_public_path__ + "static/media/star-calendar_yellow-reversed.e50c99d58e36e7e33619d0831ed91285.svg";
export { ForwardRef as ReactComponent };